import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { SpinCongratModalBg } from "@assets";

export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		border: none !important;
		background-image: url(${SpinCongratModalBg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		width: 365px !important;
		height: 423px !important;
		/* height: 3px; */
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px !important;
			height: 323px !important;
		}
	}
`;

export const ModalTitle = styled.p`
	color: #FFF;
	font-size: 20px;
	font-weight: 500;
	line-height: 18.26px;

	margin-top: 160px;
	@media screen and (max-width: 413px) {
		margin-top: 110px;
		font-size: 18px;
		font-weight: 500;
		line-height: 15px;
	}
`;

export const ModalLabel = styled.p`
	color: #FFF;
	font-size: 14px;
	font-weight: 400;
	line-height: 18.26px;
	margin-top: 8px;
	@media screen and (max-width: 413px) {
		font-size: 10px;
		line-height: 15px;
	}
`;

export const AmountWrapper = styled.div`
	font-weight: 500;
	font-size: 20px;
	line-height: normal;
	align-items: center;
	color: #FFF;

	margin-top: 16px;
	@media screen and (max-width: 413px) {
		font-size: 18px;
		line-height: normal;
	}
`;

export const OkWrapper = styled.div`
	width: calc(100% - 48px);
	height: 37.39px;
	border-radius: 28px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	background-color: #FFF;

	font-weight: 600;
	font-size: 16px;
	line-height: 22.83px;
	color: #000;
	cursor: pointer;
	@media screen and (max-width: 413px) {
		margin-top: 15px;
		font-weight: 600;
		font-size: 17px;
		line-height: 20px;
	}
`;

export const ExpiredText = styled.div`
	width: 90%;
	font-size: 12px;
	font-weight: 400;
	line-height: 18.26px;
	color: #FFF;
	margin: 20px auto 0;
	@media screen and (max-width: 413px) {
		font-size: 8px;
		font-weight: 600;
		line-height: 15px;
	}
`;

// export const ExpiredDate = styled.span`
// 	color: #e8a442;
// `;
